<template>
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-position="left"
      label-width="0px"
      v-loading="loading"
    >
      <el-form-item prop="majorMaterialId">
        <el-input
          type="text"
          v-model="form.majorMaterial.name"
          autocomplete="off"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item prop="model">
        <el-input
          type="text"
          v-model="form.majorMaterial.model"
          autocomplete="off"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item prop="date">
         <el-date-picker
          v-model="form.date"
          type="month"
          placeholder="选择时间"
          :clearable="false"
          style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="majorMaterialRegionId">
        <el-select
        v-model="form.majorMaterialRegion.id"
        filterable
        placeholder="请选择地区"
        style="width: 100%;"
        >
          <el-option
            v-for="item in majorMaterialRegions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="price">
        <el-input
          type="text"
          v-model="form.price"
          autocomplete="off"
          placeholder="含税信息价"
        ></el-input>
      </el-form-item>
      <el-form-item prop="priceNoTax">
        <el-input
          type="text"
          v-model="form.priceNoTax"
          autocomplete="off"
          placeholder="除税信息价"
        ></el-input>
      </el-form-item>
      <el-form-item style="width: 100%" v-if="type == 'add'">
        <el-button
          type="primary"
          style="width: 100%;border: none"
          v-on:click="add('form')"
          >新建</el-button
        >
      </el-form-item>
      <el-form-item style="width: 100%" v-if="type == 'edit'">
        <el-button
          type="primary"
          style="width: 100%;border: none"
          v-on:click="edit('form')"
          >更新</el-button
        >
      </el-form-item>
    </el-form>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    form: {
      majorMaterial: {},
      majorMaterialRegion: {},
      price: '',
      priceNoTax: '',
      date: null
    },
    rules: {}
  },

  data () {
    return {
      majorMaterialRegions: [],
      loading: false
    }
  },

  mounted () {
    var self = this
    this.getRequest('/major_material_regions')
      .then(resp => {
        if (resp && resp.result) {
          self.$data.majorMaterialRegions = resp.result
        }
      })
  },

  methods: {
    add (formName) {
      var _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/major_material_price/add', _this.form)
            .then(resp => {
              if (resp && resp.code === 200) {
                _this.$router.replace('/major_material_prices/' + this.form.majorMaterial.id)
              } else {
                this.$data.loading = false
              }
            })
        }
      })
    },

    edit (formName) {
      var _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$data.loading = true
          this.putRequest('/major_material_price/edit', _this.form)
            .then(resp => {
              if (resp && resp.code === 200) {
                _this.$router.replace('/major_material_prices/' + this.form.majorMaterial.id)
              } else {
                this.$data.loading = false
              }
            })
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
